export const PaymentAmountType = Object.freeze({
    ADVANCED: "ADVANCED_AMOUNT",
    DEBT: "DEBT_AMOUNT",
    COMBINED: "COMBINED_AMOUNT",
});
